import React, { FC } from 'react';
import BananatagButton from '../../../componentLibrary/BananatagButton';
import Modal from '../../../componentLibrary/Modal';
import rules from '../../../constants/businessRules/businessRules';
import * as Styled from './styles';

interface IProps {
    closeModal: () => void;
}

const HtmlSizeWarningModal: FC<IProps> = ({ closeModal }) => (
    <Modal onEsc={closeModal}>
        <Styled.Icon icon="exclamation-triangle" />
        <Styled.Header>Email Draft Too Large</Styled.Header>
        <Styled.Text>
            {`The maximum sendable size of an email is ${rules.HTML_MAX_CONTENT_SIZE / 1024 / 1024} MB. Your email draft has been saved but please remember to reduce the size of your email before sending.`}
        </Styled.Text>
        <Styled.ButtonWrapper>
            <BananatagButton type="solid" size="large" onClick={closeModal} text="OK" />
        </Styled.ButtonWrapper>
    </Modal>
);

export default HtmlSizeWarningModal;
